<template>
	<section :id="data.id" class="our-team">
		<div class="container">
			<h2 class="heading">{{ team.title }}</h2>
			<div class="our-team-members">
				<TeamMember
					v-for="(member, index) in team.teamMembers"
					:key="`${member.sys.id}-${index}`"
					:id="member?.sys?.id"
					:content="member.fields"
					:class="{ 'highlight-member': bioContent?.id === member?.sys?.id }"
				/>
			</div>
			<Transition
				name="show-bio"
				@after-leave="clearBio"
			>
				<div class="team-member-bio" v-if="showBio">
					<div class="team-member-bio-content">
						<div class="team-member-bio-close" v-on:click="closeBio">+</div>
						<template v-if="bioContent">
							<RichText :content="bioContent" />
						</template>
					</div>
				</div>
			</Transition>

		</div>
	</section>
</template>

<script setup>
import { useTeamMemberCloseBio } from '~~/composables/useTeamMemberCloseBio.js';
import { useTeamMemberGetBio } from '~~/composables/useTeamMemberGetBio.js';

const bioContent = ref(null);
const getBio = useTeamMemberGetBio();
const showBio = ref(false);
const props = defineProps({
	data: {
		type: Object
	}
});

const team = computed(() => props?.data?.data ?? []);
const closeMemberBio = useTeamMemberCloseBio();
const closeBio = () => {
	showBio.value = false;

	closeMemberBio.value = false;
};

const clearBio = () => {
	getBio.value = null;
};

watch(getBio, (value) => {
	if(value) {
		bioContent.value = value;
		showBio.value = true;
	} else {
		showBio.value = false;
	}
});
</script>

<style lang="scss">
@use '~/assets/scss/components/OurTeam.scss';
</style>